import { axiosBaseQuery } from '@client';
import { getEnvironmentVariables } from '@common';
import { createApi } from '@reduxjs/toolkit/query/react';
import axios from 'axios';
import {
  LoginAccountOption,
  DisambiguateResponse,
  DisambiguateRequest
} from '@state/stores/login-account-picker';

const { API_URL } = getEnvironmentVariables();

const axiosWithoutInterceptors = axios.create({
  baseURL: `${API_URL}/da-app`
});

export const accountPickerApi = createApi({
  reducerPath: 'account-picker_api',
  baseQuery: axiosBaseQuery({
    baseUrl: '/multi-profile',
    customAxiosInstance: axiosWithoutInterceptors
  }),
  endpoints: (build) => ({
    getAccountPicker: build.query<LoginAccountOption[], { token: string }>({
      query: ({ token }) => ({
        url: `/account-picker`,
        method: 'GET',
        params: { t: token }
      })
    }),

    disambiguate: build.mutation<DisambiguateResponse, DisambiguateRequest>({
      query: (payload) => ({
        url: `/disambiguate`,
        method: 'POST',
        data: payload
      })
    })
  })
});

export const { useLazyGetAccountPickerQuery, useDisambiguateMutation } =
  accountPickerApi;
